import * as React from 'react';
import { useClickController } from '../../internal';
import { CustomTooltip } from '../CustomTooltip';

/**
 * Компонент подсказки в виде всплывающего текста
 *
 * @export
 * @param {IInformationTooltipDesktopProps} props
 * @returns
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function InformationTooltipDesktop(props) {
  const {
    header,
    content,
    arrow,
    placement,
    theme,
    portal
  } = props;
  const {
    childrenProps,
    childrenRef,
    open,
    handleClose
  } = useClickController(props);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(props.children, childrenProps), /*#__PURE__*/_jsx(CustomTooltip, {
      header: header,
      content: content,
      open: open,
      anchorRef: childrenRef,
      arrow: arrow,
      placement: placement,
      theme: theme,
      size: "M",
      portal: portal,
      flip: true,
      preventOverflow: true,
      closeButton: true,
      outside: true,
      onClose: handleClose
    })]
  });
}